import type { FeatureFlagKey } from '../registry/feature-flags';

/**
 * Deduplicates an array of feature flag keys to prevent redundant evaluations.
 *
 * @param flagKeys - Array of feature flag keys (may contain duplicates)
 * @returns Array of unique feature flag keys in the same order as first occurrence
 *
 * @example
 * ```typescript
 * const flags = deduplicateFlagKeys(['flag1', 'flag2', 'flag1', 'flag3']);
 * // Returns: ['flag1', 'flag2', 'flag3']
 * ```
 */
export function deduplicateFlagKeys(
  flagKeys: readonly FeatureFlagKey[],
): FeatureFlagKey[] {
  return Array.from(new Set(flagKeys));
}
